import { Component, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { ContactsAppStateService } from '@modules/contacts/services/state.service';

import { Contact } from '@modules/contacts/types/contact';
import { Group } from '@modules/contacts/types/group';
import { ListState } from '@modules/contacts/types/list-state';

import { FullFormBaseComponent } from '@modules/common/components/full-form-base/full-form-base.component';
import { AbstractMainViewComponent } from '@modules/common/components/main-view/main-view.component';
import { getStitchInstanceByStitchType } from '@modules/common/utils/stitch';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'app-contacts-main-view',
  templateUrl: './main-view.component.html',
  styleUrls: ['./main-view.component.less'],
  standalone: false,
})
export class ContactsMainViewComponent extends AbstractMainViewComponent<
  StitchType.CONTACT | StitchType.GROUP,
  Contact | Group,
  FullFormBaseComponent<StitchType.CONTACT | StitchType.GROUP, Contact | Group, Record<string, AbstractControl>>,
  ListState
> {
  protected override readonly stateService = inject(ContactsAppStateService);

  asContact(item: Contact | Group): Contact {
    return item as Contact;
  }

  asGroup(item: Contact | Group): Group {
    return item as Group;
  }

  protected handleNewContact(): void {
    this.openCreateModal(getStitchInstanceByStitchType(StitchType.CONTACT));
  }

  protected handleNewGroup(): void {
    this.openCreateModal(getStitchInstanceByStitchType(StitchType.GROUP));
  }
}
